import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EventService } from 'src/app/services/event.service';
import { Event } from 'src/app/models/event';
import { NotificationService } from 'src/app/services/notification.service';
import { MatTableDataSource } from '@angular/material/table';
import { EventParticipant } from 'src/app/models/event-participant';

@Component({
    selector: 'app-event-presence-list',
    templateUrl: './event-presence-list.component.html',
    styleUrls: ['./event-presence-list.component.scss']
})

export class EventPresenceListComponent implements OnInit {
    event?: Event;
    dataSource = new MatTableDataSource<EventParticipant>();
    displayedColumns: string[] = ['description', 'wasPresent', 'actions'];

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<EventPresenceListComponent>, private eventService: EventService,
        private notificationService: NotificationService) { }

    ngOnInit() {
        this.getEvent();
    }

    getEvent() {
        this.eventService.getEventByID({ id: this.data.eventID }).subscribe({
            next: event => {
                this.event = event;
                this.dataSource.data = event.participants ?? [];
            },
            error: error => {
                this.notificationService.error(error);
            }
        });
    }

    applyFilter = (value: string) => {
        this.dataSource.filter = value.trim().toLocaleLowerCase();
    }

    markAsPresent(participant: EventParticipant) {
        this.eventService.updateEventParticipant(this.event.id, { id: this.event.id, associateID: participant.associateID, isPresent: true }).subscribe({
            next: () => {
                this.getEvent();
                this.notificationService.sucess(`${participant.associate} marcado(a) como presente`);
            },
            error: error => {
                this.notificationService.error(error);
            }
        });
    }

    markAsAbsent(participant: EventParticipant) {
        this.eventService.updateEventParticipant(this.event.id, { id: this.event.id, associateID: participant.associateID, isPresent: false }).subscribe({
            next: () => {
                this.getEvent();
                this.notificationService.sucess(`${participant.associate} marcado(a) como ausente`);
            },
            error: error => {
                this.notificationService.error(error);
            }
        });
    }

    close() {
        this.dialogRef.close();
    }
}
